const OUR_SUPLLIERS = '[CMS_OUR_SUPPLIERS]';

const types = {
  GET_SUPPLIERS: `${OUR_SUPLLIERS} GET_SUPPLIERS`,
  SET_SUPPLIERS: `${OUR_SUPLLIERS} SET_SUPPLIERS`,
  
};

export default types;
